/**
 * AI Chat Hook (Stub)
 * 
 * This is a placeholder for future AI chat integration.
 * Currently not used in the Phase 3A/4 workflow.
 */

export interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  isUser: boolean;
}

export interface UseAIChatReturn {
  messages: Message[];
  sendMessage: (input: string) => Promise<void>;
  isLoading: boolean;
  error: string | null;
  retryLastMessage: () => Promise<void>;
  networkError: boolean;
  providerStatus: 'online' | 'offline';
}

export function useAIChat(_enabled: boolean = false): UseAIChatReturn {
  return {
    messages: [],
    sendMessage: async (_input: string) => {
      console.warn('useAIChat is not implemented yet');
    },
    isLoading: false,
    error: null,
    retryLastMessage: async () => {
      console.warn('retryLastMessage is not implemented yet');
    },
    networkError: false,
    providerStatus: 'online',
  };
}
